var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorTiffanyblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15719",
    "data-name": "Group 15719",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.528,
    height: 69.875,
    viewBox: "0 0 54.528 69.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16477",
    "data-name": "Rectangle 16477",
    width: 54.528,
    height: 69.875,
    fill: "#29bcc1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15718",
    "data-name": "Group 15718",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41320",
    "data-name": "Path 41320",
    d: "M14.08,121.987c-.755,2.5-1.575,4.9-2.2,7.354-.613,2.415-1.049,4.877-1.508,7.328a.848.848,0,0,1-.67.77,5.963,5.963,0,1,0,4.212.135c-.226-.094-.457-.178-.706-.275a67.92,67.92,0,0,1,3.179-12.814c.444-1.237.946-2.455,1.468-3.661a1.062,1.062,0,0,1,.644-.566,42.416,42.416,0,0,1,5.563-.906,36.007,36.007,0,0,1,11.116.69.8.8,0,0,1,.687.691,46.685,46.685,0,0,1,1.368,8.249.945.945,0,0,1-.634,1.029,22.552,22.552,0,0,0-8.036,6.179,9.182,9.182,0,0,0-1.917,4.447,6.808,6.808,0,0,0,3.387,6.453,1.433,1.433,0,0,0,1.676-2.286c-.307-.3-.674-.541-.982-.841a3.522,3.522,0,0,1-.931-4.043,10.311,10.311,0,0,1,3.8-4.621c1.292-.954,2.7-1.75,4.079-2.584a.75.75,0,0,1,.691.006A18.883,18.883,0,0,1,43.7,139.94a8.422,8.422,0,0,1,.434,1.78,3.647,3.647,0,0,1-2.377,4.009c-.187.082-.383.142-.568.228a1.431,1.431,0,0,0-.808,1.911,1.446,1.446,0,0,0,1.873.77,6.746,6.746,0,0,0,4.575-8.418,16.588,16.588,0,0,0-3.836-6.9c-.8-.929-1.7-1.768-2.541-2.663a1.043,1.043,0,0,1-.344-.6,33.546,33.546,0,0,0-1.083-8.49,1.024,1.024,0,0,1,.02-.246,24.464,24.464,0,0,1,6.471,4,25.116,25.116,0,0,1,8.709,15.666,28.036,28.036,0,0,1,.277,3.941c.038,3.206.014,6.413.012,9.62,0,1.475-.5,1.979-1.946,1.979H1.942c-1.43,0-1.944-.494-1.937-1.91.018-3.843-.067-7.69.1-11.527A24.175,24.175,0,0,1,6.25,128.057a24.978,24.978,0,0,1,7.83-6.07",
    transform: "translate(0 -86.648)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41321",
    "data-name": "Path 41321",
    d: "M59.453,30.345A15.172,15.172,0,1,1,74.584,15.076,15.152,15.152,0,0,1,59.453,30.345",
    transform: "translate(-32.166 0)",
    fill: "#29bcc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorTiffanyblue);
export default __webpack_public_path__ + "static/media/doctor-tiffanyblue.a99bde73a122b42741aa183082e0874b.svg";
export { ForwardRef as ReactComponent };